import * as actionTypes from './actionTypes';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';

export const addDateSelected = (date: any, idPrint: number) => ({
  type: actionTypes.ADD_DATE_SELECTED,
  date,
  idPrint
});

export const addDateSelectedAll = (dates: any, idPrint: number) => ({
  type: actionTypes.ADD_ALL_DATE_SELECTED,
  dates,
  idPrint
});


export const deleteDateSelected = (date: DateSelectedType, idPrint: number) => ({
  type: actionTypes.DELETE_DATE_SELECTED,
  date,
  idPrint
});

export const deleteAllDateSelected = (idPrint: number) => ({
  type: actionTypes.DELETE_ALL_DATE_SELECTED,
  idPrint
});

export const setCalendarDate = (printData: any) => ({
  type: actionTypes.SET_CALENDAR_DATE,
  printData
});

export const cleanAllDateSelected = () => ({
  type: actionTypes.CLEAN_ALL_DATE_SELECTED
});